import { BSC } from '../types';
export default {
  type: BSC,
  service: 'bscscan.com',
  url: 'https://bsc-dataseed1.binance.org',
  port: 443,
  auth: false,
  username: '',
  password: ''
};
